import { AbstractReportPmsApiService } from '../abstract-report.service';
import { ReservationByRatePlan } from '../../../models/reports/production/reservation-by-rate-plan.model';

/**
 * @class ReservationsByRatePlanReportPmsApiService
 * @extends {AbstractReportPmsApiService<ReservationByRatePlan>}
 */
export class ReservationsByRatePlanReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/production/reservations-by-rate-plan';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ReservationByRatePlan}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ReservationByRatePlan(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/production/reservations-by-rate-plan-report.service.js